import React, { useState, useEffect, useCallback } from 'react'
import { Box, Drawer, styled, Typography } from '@mui/material'
import { Panel, PanelGroup, PanelResizeHandle } from 'react-resizable-panels';
// import CreateRegulatoryDialog from './components/CreateRegulatoryDialog';
// import EditRegulatoryDialog from './components/EditRegulatoryDialog';
import { useTheme } from '@emotion/react';
import DPEManagement from '../../../components/DPEManagement';
import { getOpenDrawerLeft } from '../../../redux/drgMgtSlice';
import { useDispatch, useSelector } from 'react-redux';
import PolicyComponents from './components/PolicyComponents';
import { applyNodeChanges, ReactFlowProvider, useEdgesState, useNodesState } from '@xyflow/react';
import PolicyDiagram from './diagram/PolicyDiagram';
import CustomizedSnackbar from '../../../components/CustomizedSnackbar';
import checkUpdateSubjectSchema from '../../../utils/checkUpdateSubjectSchema';
import PolicySimulatorPanel from './PolicySimulatorPanel';
import { getOpenSimulatorPolicy, setOpenSimulatorPolicy } from '../../../redux/openSimulatorPolicySlice';
import { getProfile } from '../../../redux/iaamSlice';

const drawerWidth = 270;

const Main = styled('main', { shouldForwardProp: (prop) => prop !== 'open' })(
    ({ theme, open }) => ({
        flexGrow: 1,
        transition: theme.transitions.create('margin', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        [theme.breakpoints.only('xs')]: {
            marginLeft: 0,
        },
        marginLeft: `-${drawerWidth}px`,
        ...(open && {
            transition: theme.transitions.create('margin', {
                easing: theme.transitions.easing.easeOut,
                duration: theme.transitions.duration.enteringScreen,
            }),
            marginLeft: 0,
        }),
    }),
);

function PolicyPage() {
    const theme = useTheme();
    const dispatch = useDispatch();

    const openDrawerLeft = useSelector(getOpenDrawerLeft);
    const openSimulatorPolicy = useSelector(getOpenSimulatorPolicy);
    const profile = useSelector(getProfile);

    const [isDPEUpdate, setIsDPEUpdate] = useState(false);
    const [policyFile, setPolicyFile] = useState(undefined);
    const [project, setProject] = useState(null);
    const [nodes, setNodes] = useState([]);
    const [edges, setEdges] = useState([]);
    // const [nodes, setNodes, onNodesChange] = useNodesState([]);
    // const [edges, setEdges, onEdgesChange] = useEdgesState([]);

    useEffect(() => {
        const project = JSON.parse(localStorage.getItem('project'));
        if (project) {
            setProject(project);
        }
        const file = JSON.parse(localStorage.getItem('policy-file'));
        if (file) {
            // เปรียบเทียบ policy_diagram_id เพื่อลดการ re-render
            setPolicyFile((prevFile) => {
                if (prevFile?.policy_diagram_id === file.policy_diagram_id) {
                    return prevFile;
                }
                return file;
            });
        }
    }, []);

    useEffect(() => {
        const getSubjectSchema = async () => {
            await checkUpdateSubjectSchema(dispatch);
        }
        getSubjectSchema();
    }, [])

    const onClosePanel = () => {
        dispatch(setOpenSimulatorPolicy(false));
    };

    // const handleNodesChange = useCallback((changes) => {
    //     setNodes((nds) => {
    //         const oldNodes = nds.map((node) => ({
    //             ...node,
    //             measured: {
    //                 width: node?.measured?.width || 150,
    //                 height: node?.measured?.height || 40,
    //             }
    //         }));
    //         return applyNodeChanges(changes, oldNodes); // อย่าลืม import applyNodeChanges
    //     });
    // }, [setNodes]);

    return (
        <section className="flex w-full overflow-hidden">
            {openSimulatorPolicy ? (
                <></>
            ) : (
                <Drawer
                    open={true}
                    variant="persistent"
                    sx={{
                        width: drawerWidth,
                        flexShrink: 0,
                        [`& .MuiDrawer-paper`]: { width: drawerWidth, boxSizing: 'border-box', marginTop: "48px" },
                        zIndex: 1
                    }}
                >
                    <Box sx={{ width: '100%', height: '100%' }}>
                        <Box className="p-4">
                            <Typography variant='subtitle2' mb={2}>Components</Typography>
                            <PolicyComponents />
                        </Box>
                    </Box>

                </Drawer>
            )}
            <Main open={openDrawerLeft}>
                <ReactFlowProvider>
                    <PanelGroup direction="vertical">
                        <Panel>
                            <PolicyDiagram
                                project={project}
                                profile={profile}
                                policyFile={policyFile}
                                setPolicyFile={setPolicyFile}
                                nodes={nodes}
                                setNodes={setNodes}
                                edges={edges}
                                setEdges={setEdges}
                            // onNodesChange={handleNodesChange}
                            // onEdgesChange={onEdgesChange}
                            // isDPEUpdate={isDPEUpdate}
                            // setIsDPEUpdate={setIsDPEUpdate}
                            />
                        </Panel>
                        {(openSimulatorPolicy) && (<>
                            <PanelResizeHandle className='h-0.5 bg-slate-300 hover:bg-slate-400' />
                            <PolicySimulatorPanel onClose={onClosePanel} nodes={nodes} />
                        </>
                        )}
                    </PanelGroup>
                </ReactFlowProvider>
            </Main>
            <CustomizedSnackbar />
        </section>
    )
}

export default PolicyPage